<!-- <div id="cover-spin" ></div> -->
<div class="loaderIcon">
    <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
</div>
